import * as validationLib from "../../lib/validation";
import cn from "../../lib/classnames";
import editImage from "../../images/edit_24dp.svg";
import React, {useRef} from "react";
import ReviewLabel from "../ReviewLabel";
import styles from "./ReviewInput.module.css";
import textStyles from "../../styles/Text.module.css";
import {InputType} from "../LinedInput";

type Props = React.ComponentProps<"input"> & {
    id: string;
    title: string;
    value: string;
    message?: string;
    placeholder?: string;
    renderSelectAll?: boolean;
    selectAll?: () => void;
    type?: string;
    validationMessage?: string[];
};

function ReviewInput(
    {
        id,
        title,
        value,
        message,
        onBlur,
        onChange,
        className,
        placeholder = "Write the title of your review here.",
        renderSelectAll = true,
        selectAll,
        type = InputType.Text,
        validationMessage,
        ...rest
    }: Props,
    ref: React.ForwardedRef<HTMLInputElement>,
) {
    const titleRef = useRef<HTMLInputElement>(null);
    function focusAndSelectAll() {
        titleRef.current?.focus();
        titleRef.current?.select();
    }

    return (
        <div className={className}>
            <ReviewLabel className={styles.reviewLabel} label={title} htmlFor={id} />
            <div className={styles.titleContainer}>
                <input
                    className={styles.textArea}
                    onBlur={onBlur}
                    onChange={onChange}
                    placeholder={placeholder}
                    value={value}
                    ref={ref ? ref : titleRef}
                    type={type}
                    {...rest}
                />
                {renderSelectAll ? (
                    <button
                        onClick={selectAll ? selectAll : focusAndSelectAll}
                        className={styles.imageContainer}
                        type="button"
                    >
                        <img className={styles.editImage} alt="Edit" src={editImage} />
                    </button>
                ) : null}
            </div>
            <div className={styles.allMessages}>
                {message ? <div>{message}</div> : null}
                {validationMessage && validationMessage.length ? (
                    <div className={cn(textStyles.inputError, styles.validation)}>
                        {validationLib.getDisplayString(validationMessage)}
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default React.forwardRef<HTMLInputElement, Props>(ReviewInput);
